import { render } from "./SessionResponsive.vue?vue&type=template&id=bb035f84&scoped=true"
import script from "./SessionResponsive.vue?vue&type=script&lang=js"
export * from "./SessionResponsive.vue?vue&type=script&lang=js"

import "./SessionResponsive.vue?vue&type=style&index=0&id=bb035f84&scoped=true&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb035f84"]])

export default __exports__